import { createApp } from 'vue'
import i18n from './i18n'

import BookNow from './components/BookNow.vue'

const app = createApp({
  el: '#bookTour',
  delimiters: ['[[', ']]'],
  components: {
    BookNow
  },

  setup() {
    return {}
  },
})
app.use(i18n).mount('#bookTour')


